import React from 'react';
import SetaLogo from './SetaLogo';
import { aboutText } from '../mock';

const About = () => {
  return (
    <section
      id="sobre"
      className="relative py-24 px-6"
      style={{
        background: 'linear-gradient(180deg, #0e0e0e 0%, #1c1c1c 60%, #2a2a2a 100%)',
      }}
    >
      <div className="max-w-4xl mx-auto text-center">
        <p className="text-[#C99A36] tracking-[0.4em] text-[12px] font-semibold mb-6" style={{ fontFamily: "'Montserrat', sans-serif" }}>
          A SETA
        </p>
        <div className="flex justify-center mb-10">
          <SetaLogo height={110} variant="dark" />
        </div>

        <p
          className="text-white/90 leading-[1.9] text-[15px] md:text-[16px] tracking-wide text-justify"
          style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}
        >
          {aboutText}
        </p>
      </div>
    </section>
  );
};

export default About;
